import React from 'react';
import planIcon from '../../../../../../assets/image/subscription/plan-icon.svg';
import Button from '../../../../../../component/ui/Button';
import { format2DigitDate } from '../../../../../../utils/constant';

export default function CurrentPlanComponents({
	currentPlan,
	setIsOpenCancelSubscriptionModal,
	setSubscriptionScreenType,
}) {
	return (
		<div>
			<div className="fs-3 fw-semibold py-2">Current Subscription</div>
			<div
				className="d-flex justify-content-between align-items-center rounded-3 p-2"
				style={{
					border: '1px solid rgba(85, 91, 103, 0.15)',
					backgroundColor: 'rgba(252, 252, 252, 1)',
				}}
			>
				<div className="d-flex justify-content-start align-items-center">
					<img
						src={planIcon}
						className="px-2"
						alt="icon"
					/>
					<div className="px-3">
						<div className="d-flex gap-4 align-items-center">
							<div className="fs-4 font-medium">{`${currentPlan?.plan?.name || 'Free Plan'}`}</div>
							<div
								className="p-2 fs-5 font-small rounded-4"
								style={{ backgroundColor: '#F0FFE6', color: '#68C230', width: '50px' }}
							>
								{currentPlan?.status}
							</div>
						</div>
						<div className="fs-5 font-small">{currentPlan?.plan?.description || '---'}</div>
						<div className="fs-5 font-small">{`Subscription Id : ${currentPlan?.razorpay_subscription_id || '---'}`}</div>
					</div>
				</div>
				<div className="subscription-divider"></div>
				<div className="px-3">
					<div className="d-flex gap-4 align-items-center">
						<div className="fs-4 font-medium">{'Amount'}</div>
					</div>
					<div className="fs-5 font-small">{`₹ ${currentPlan?.amount} / ${currentPlan?.billing_period || 'Monthly'}`}</div>
					<div className="fs-5 font-small">{`Billed ${currentPlan?.billing_period || 'Monthly'}`}</div>
				</div>
				<div className="subscription-divider"></div>
				<div className="px-3">
					<div className="d-flex gap-4 align-items-center">
						<div className="fs-4 font-medium">{'validity'}</div>
					</div>
					<div className="fs-5 font-small">{`${currentPlan?.current_start !== null ? format2DigitDate(currentPlan?.current_start) : ''} - ${currentPlan?.current_end !== null ? format2DigitDate(currentPlan?.current_end) : ''}`}</div>
					<div className="fs-5 font-small">{`Next billing on ${currentPlan?.next_billing_date !== null ? format2DigitDate(currentPlan?.next_billing_date) : ''}`}</div>
				</div>
				<div className="subscription-divider"></div>
				<div className="px-3">
					<div className="d-flex gap-4 align-items-center">
						<div className="fs-4 font-medium">{'Status'}</div>
					</div>
					<div
						className="p-2 fs-5 font-small rounded-4"
						style={{ backgroundColor: '#F0FFE6', color: '#68C230', width: '50px' }}
					>
						{currentPlan?.status}
					</div>
					<div className="fs-5 font-small">{`Auto-renewal in ${currentPlan.is_recurring ? 'ON' : 'OFF'}`}</div>
				</div>
				<div className="align-items-center px-5 py-4">
					<Button
						type="button"
						className="mt-0 btn-primary fs-5 fw-light add-pro py-1 px-4 "
						button="Manage Billing"
						onClick={() => setSubscriptionScreenType('manage-billing')}
					/>
					<div
						className="mt-3 fs-5 font-small text-danger cursor-pointer"
						onClick={() => setIsOpenCancelSubscriptionModal(true)}
					>
						Cancel Subscription
					</div>
				</div>
			</div>
		</div>
	);
}
